import { render, staticRenderFns } from "./RatingSelector.vue?vue&type=template&id=cb75fabc&"
import script from "./RatingSelector.vue?vue&type=script&lang=ts&"
export * from "./RatingSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports